import BaseEntity from '../base/BaseEntity.model';
import Direccion from '../direccion.model';

export default class Hogar extends BaseEntity {
    public codigo?: string;
    public diccionId?: number;
    public direccion?: Direccion;
    constructor() {
        super();
        this.init();
    }

    init() {
        this.id = undefined;
        this.diccionId = undefined;
        this.direccion = undefined;
    }
}

